// ABOUTME: Public, unauthenticated reads behind a /p/{token} preview link — the
// variants of one planned post and the platform spec table each mockup is drawn
// from. Types mirror the snake_case payload of app/services/previews/payload.py.
import { api } from '@/api/client'

export interface PreviewInsets {
  top: number
  right: number
  bottom: number
  left: number
}

export interface PreviewSurfaceSpec {
  key: string
  platform: string
  label: string
  structures: string[]
  frame: [number, number]
  fit: 'cover' | 'contain'
  caption_lines: number | null
  caption_chars: number | null
  more_label: string
  caption_overlay: boolean
  safe_zone: PreviewInsets
  grid_crop: [number, number] | null
  avatar: 'circle' | 'square'
  max_media: number
}

export interface PreviewMediaItem {
  url: string
  poster_url: string | null
  kind: string
  mime_type?: string
  width?: number | null
  height?: number | null
  sha256?: string | null
}

export interface PreviewVariantSurface {
  surface: string
  caption: string
  caption_shown: string
  caption_truncated: boolean
  /** Indexes into the variant's media: exactly what this platform posts. */
  media_indexes: number[]
}

export interface PreviewVariant {
  position: number
  structure: string
  media: PreviewMediaItem[]
  surfaces: PreviewVariantSurface[]
}

export interface PostPreview {
  kind: 'options'
  business: { name: string }
  expires_at: string
  og_image_url: string
  variants: PreviewVariant[]
  surfaces: Record<string, PreviewSurfaceSpec>
}

const API_ORIGIN = (
  import.meta.env.VITE_API_URL || `http://localhost:${__BACKEND_PORT__}/api/v1`
).replace(/\/api\/v1\/?$/, '')

/** Preview media paths are API routes; anything else (an external URL) passes through. */
export function previewAssetUrl(url: string): string {
  return url.startsWith('/api/') ? `${API_ORIGIN}${url}` : url
}

export async function fetchPostPreview(token: string): Promise<PostPreview> {
  return (await api.get<PostPreview>(`/previews/${token}`)) as unknown as PostPreview
}
